import styled from '@emotion/styled';
import { Button as _Button, MenuItem, Menu, ListItemText } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { SPACING_LARGE, SPACING_UNIT } from '../../../constant/spacing';
import { ClassAttributes, Component, createElement, MouseEvent } from 'react';
import Language from '../../../../entity/Language';
import { Globe } from '../../primitive/Icons';

interface Props {
  onSubmit: (lang: Language) => void;
}

interface State {
  open: boolean;
  anchorEl: HTMLElement | undefined;
}

const initialState = {
  open: false,
  anchorEl: undefined,
};

class LangMenu extends Component<ClassAttributes<HTMLElement> & Props, State> {
  state = initialState;
  private onClickMenu = (e: MouseEvent<HTMLElement>) => {
    this.setState({ open: true, anchorEl: e.currentTarget });
  };
  private onRequestClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { onSubmit } = this.props;
    return (
      <div>
        <Button onClick={this.onClickMenu}>
          <GlobeIcon />
        </Button>
        <StyledMenu
          id="menu-appbar"
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={this.state.open}
          onClose={this.onRequestClose}
        >
          <MenuItem button onClick={() => onSubmit('ja-JP')}>
            <ListItemText primary={<FormattedMessage id="language.ja-JP" />} />
          </MenuItem>
          <MenuItem button onClick={() => onSubmit('en-US')}>
            <ListItemText primary={<FormattedMessage id="language.en-US" />} />
          </MenuItem>
        </StyledMenu>
      </div>
    );
  }
}

const Button = styled(_Button)({
  padding: SPACING_UNIT / 2,
  textTransform: 'none',
}) as typeof _Button;

const StyledMenu = styled(Menu)({
  marginTop: SPACING_LARGE,
}) as typeof Menu;

const GlobeIcon = styled(Globe)({});

export default LangMenu;
